import FamilyMedicalHistoryLandingContainer from "./container/FamilyMedicalHistoryLandingContainer";

export default FamilyMedicalHistoryLandingContainer;
